module.exports = __webpack_public_path__ + "static/media/MH-web-graphics-left.f64d70ff.svg";